/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleGlobalUpdateRequestTitle } from './moduleGlobalUpdateRequestTitle';
import type { ModuleGlobalUpdateRequestAuthor } from './moduleGlobalUpdateRequestAuthor';
import type { ModuleGlobalUpdateRequestIsDeprecated } from './moduleGlobalUpdateRequestIsDeprecated';
import type { ModuleGlobalUpdateRequestMandates } from './moduleGlobalUpdateRequestMandates';

/**
 * Schema for updating global module properties across all versions

This is a subset of ModuleUpdateRequest, only containing fields
that should be consistent across all module versions, like title.
 */
export interface ModuleGlobalUpdateRequest {
  title?: ModuleGlobalUpdateRequestTitle;
  author?: ModuleGlobalUpdateRequestAuthor;
  isDeprecated?: ModuleGlobalUpdateRequestIsDeprecated;
  mandates?: ModuleGlobalUpdateRequestMandates;
  propagateMandates?: boolean;
}
